import '../../../../../../../components/Graph/chartSetup';
import { TargetTypes } from '../../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';
import GraphContent from '../../../../../../../components/Graph/graphContent';

interface GraphTargetContentProperties {
	targetId: string;
	targetName: string;
	type: TargetTypes;
}

const GraphTargetContent = ({ targetId, targetName, type }: GraphTargetContentProperties) => (
	<GraphContent graphType="target" id={targetId} data={{ name: targetName, type }} />
);

export default GraphTargetContent;
